import { combineReducers } from 'redux';
import { coreUsersByIdSalesforcePreferencesGetAsyncSlice } from './get';
import { coreUsersByIdSalesforcePreferencesPatchAsyncSlice } from './patch';
import { coreUsersByIdSalesforcePreferencesUpdateSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';

export const coreUsersByIdSalesforcePreferencesReducers = combineReducers({
	get: joinReducers([
		coreUsersByIdSalesforcePreferencesGetAsyncSlice.asyncReducers,
		coreUsersByIdSalesforcePreferencesUpdateSyncSlice.syncReducer
	], coreUsersByIdSalesforcePreferencesGetAsyncSlice.asyncState),
	patch: coreUsersByIdSalesforcePreferencesPatchAsyncSlice.asyncReducers
});

export const coreUsersByIdSalesforcePreferencesWatchers = combineAllWatchers([
	coreUsersByIdSalesforcePreferencesGetAsyncSlice.asyncWatchers,
	coreUsersByIdSalesforcePreferencesPatchAsyncSlice.asyncWatchers
]);
